import { render, staticRenderFns } from "./OtherObjectivesTemplate.vue?vue&type=template&id=074c6d04&scoped=true&"
import script from "./OtherObjectivesTemplate.vue?vue&type=script&lang=js&"
export * from "./OtherObjectivesTemplate.vue?vue&type=script&lang=js&"
import style0 from "./OtherObjectivesTemplate.vue?vue&type=style&index=0&id=074c6d04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074c6d04",
  null
  
)

export default component.exports